import * as yup from 'yup';

import { isValidURL } from 'src/common/helpers';

export const officialWriteUpsUrlValidations = yup.object({
  userWriteup: yup.string().test('isValidUrl', 'Write-up url must be valid url', (val) => !!isValidURL(val as string)),
});

export const forumThreadsValidations = yup.object({
  forumLink: yup.string().test('isValidUrl', 'Thread Url must be a valid url', (val) => !!isValidURL(val as string)),
});
